import { Button, darken } from "@mui/material";
import { styled, Theme } from "@mui/material/styles";

interface PhotoPickerProps {
  buttonSize: number;
  shape?: 'circular' | 'square';
}

type ThemeProps = { theme: Theme } & PhotoPickerProps;

export const PhotoPickerContainer = styled("div")<PhotoPickerProps>(
  ({ theme, buttonSize, shape = 'circular' }: ThemeProps) => ({
    position: "relative",
    width: buttonSize,
    height: buttonSize,
    cursor: "pointer",
    borderRadius: shape === 'circular' ? '50%' : '4px',
    overflow: 'hidden',

    "&:hover > button": {
      backgroundColor: darken(theme.palette.primary.main, 0.2),
    },

    'input[type="file"]': {
      display: "none",
    },
  })
);

export const PhotoPickerUploadButton = styled(Button)<PhotoPickerProps>(
  ({ theme, buttonSize, shape = 'circular' }: ThemeProps) => ({
    width: buttonSize,
    height: buttonSize,
    backgroundColor: theme.palette.primary.main,
    borderRadius: shape === 'circular' ? '50%' : '4px',
    padding: 0,
    minWidth: 0,

    position: "absolute",
    right: 0,
    bottom: 0,

    "& svg": {
      width: buttonSize / 3,
      height: buttonSize / 3,
      color: "#fff",
    },
  })
);
